module.exports = __webpack_public_path__ + "9a726e1d22b4f0d16d7f6f8578042027.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/s/s04.jpg
// module id = 680
// module chunks = 0